import React from 'react';
import { Line } from 'react-chartjs-2';

const LineGraph = ({ series, hoverLabel, lineColour = '#50a1ff', className }) => {
	const formattedData = {
		labels: series.map(({ x }) => x),
		datasets: [
			{
				label: hoverLabel,
				fill: false,
				cubicInterpolationMode: 'monotone',
				data: series.map(({ y }) => y),
				pointRadius: 3,
				pointHitRadius: 4,
				backgroundColor: lineColour,
				borderColor: lineColour
			}
		]
	};

	// option documentation:
	// https://www.chartjs.org/docs/latest/charts/line.html#dataset-properties
	let options = {
		responsive: true,
		legend: {
			display: false
		},
		spanGaps: true,
		maintainAspectRatio: false,
		gridLines: {
			display: false,
			zeroLineWidth: 0
		},
		scales: {
			xAxes: [
				{
					display: false
				}
			],
			yAxes: [
				{
					beginAtZero: true,
					gridLines: {
						drawBorder: false
					},
					ticks: {
						suggestedMin: 0
					}
				}
			]
		}
	};

	return <Line className={className} data={formattedData} options={options} />;
};

export default LineGraph;
